var React = require('react');
var router = require('react-router');
var Link = router.Link;

var PAGE_TITLE = 'Poker Tournament Terms Glossary | Daily Tourneys';

var TERMS = require('../glossary-terms');

var Glossary = React.createClass({
  componentDidMount: function() {
    document.title = PAGE_TITLE;
  },
  componentWillUnmount: function() {
    document.title = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';
  },
  render: function() {
    var items = TERMS.map(function(item) {
      return (
        <div className="glossary-item" key={item.term}>
          <dt>{item.term}</dt>
          <dd>{item.def}</dd>
        </div>
      );
    });

    return (
      <article className="content-page glossary-page">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">Poker tournament terms</h1>
        <p className="content-lead">
          A single A–Z reference for common casino and card-room tournament language you’ll see on Daily Tourneys schedules.
        </p>
        <dl className="glossary-list">
          {items}
        </dl>
        <p className="home-intro-links">
          Browse: <Link to="/las-vegas-poker-rooms">Las Vegas</Link>
          {' · '}
          <Link to="/texas-poker-rooms">Texas</Link>
          {' · '}
          <Link to="/california-poker-rooms">California</Link>
          {' · '}
          <Link to="/allcasinos/Commerce_Casino">Commerce Casino</Link>
        </p>
        <p className="content-cta">
          New to dailies? Read <Link to="/guides/how-daily-tournaments-work">how daily casino tournaments work</Link>
          {' · '}
          <Link to="/guides/poker-tournament-faq">FAQ</Link>
          {' · '}
          <Link to="/">Search schedules</Link>
        </p>
      </article>
    );
  }
});

module.exports = Glossary;



// WEBPACK FOOTER //
// ./js/pages/glossary.jsx